import { SCREEN } from '../../utils/constants';
import { navigate } from './movePages';
import { updateLeadPortal } from '../../services/digitsCodeService';
import { loadAppointmentSummary } from '../actions/selectTimeActions';
import { eventId, form, leadInfo, setEventRoom, setEventPayload } from '../../utils/variables';
import { updateEvevntStatus } from '../../services/selectTimeService';
import { loadAppointmentConfirmed } from '../../views/components/appointmentConfirmed';
import { appointmentConfirmedListeners } from './appointmentConfirmedListeners';

export function addressCollectionListeners() {
    const container = document.querySelector('.address-collection__container');
    if (!container) return;

    const line1 = container.querySelector('#addressLine1');
    const city = container.querySelector('#addressCity');
    const state = container.querySelector('#addressState');
    const zip = container.querySelector('#addressZip');
    const btn = container.querySelector('.address-collection__btn');

    function validate() {
        const valid = line1.value.trim() && city.value.trim() && state.value.trim() && zip.value.trim();
        btn.classList.toggle('disabled', !valid);
    }

    [line1, city, state, zip, container.querySelector('#addressLine2')].forEach((el) => {
        if (el) el.addEventListener('input', validate);
    });

    btn.addEventListener('click', async () => {
        if (btn.classList.contains('disabled')) return;
        btn.classList.add('disabled');
        btn.textContent = 'Saving...';

        try {
            await updateLeadPortal(leadInfo.text_id, {
                address1: line1.value.trim(),
                address2: (container.querySelector('#addressLine2')?.value || '').trim(),
                city: city.value.trim(),
                state: state.value.trim(),
                zip: zip.value.trim(),
            });

            const needsDepositOrCard = form?.appointment_channel?.collect_card_on_booking && form?.stripe_publishable_key;
            if (needsDepositOrCard) {
                loadAppointmentSummary();
            } else {
                const confirmRes = await updateEvevntStatus(eventId);
                setEventRoom(confirmRes.data.event_room || null);
                setEventPayload(confirmRes.data);
                loadAppointmentConfirmed();
                appointmentConfirmedListeners();
                navigate(SCREEN.APPOINTMENT_CONFIRMED);
            }
        } catch (e) {
            btn.classList.remove('disabled');
            btn.textContent = 'Continue';
        }
    });
}
